import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "connections",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "connections-insights" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [],
});
